

























































































































import { computed, defineComponent, onMounted, ref, toRefs, watch } from '@vue/composition-api';
import { LoadingIcon } from 'tdesign-icons-vue';
import _ from 'lodash';

import baseSelect from '@/renderer/components/Base/BaseSelect/BaseSelect.vue';
import AgreementCheckbox, { AgreementComponent } from '@/renderer/components/Base/Agreement/AgreementCheckbox.vue';

import i18n, { i18n_t } from '@/locales/i18n';
import {
  BUSINESS_OPTIONS,
  POSITION_OPTIONS,
  SCALE_OPTIONS,
} from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import phonePrefixOptions from '@/renderer/scripts/utils/phonePrefix';
import { phonePrefixFilter } from '@/renderer/common/phoneUtils';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import tips from '@/renderer/scripts/utils/tips';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import userValidator, { validatePhoneNumber, validateSMS } from '@/renderer/components/user/compositions/userValidator';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';

import infoHeader from '@/renderer/assets/images/dialog/register-info.svg';
import enInfoHeader from '@/renderer/assets/images/dialog/info-header.svg';

export default defineComponent({
  name: 'fillRegisterMessage',
  components: {
    baseSelect,
    LoadingIcon,
    AgreementCheckbox,
  },
  props: {
    form: {
      type: Object,
      required: true,
      default: {},
    },
    errMsg: {
      type: String,
      required: true,
      default: '',
    },
    invalidNameMsg: {
      type: String,
      required: true,
      default: '',
    },
    registerLoading: {
      type: Boolean,
      required: true,
      default: false,
    },
    phoneMaxLen: {
      type: Number,
      required: true,
      default: 11,
    },
    smsText: {
      type: String,
      required: true,
      default: i18n_t('获取验证码'),
    },
    isCounting: {
      type: Boolean,
      required: true,
      default: false,
    },
    disabledFormItem: {
      type: Object,
      default: () => {
        return {
          phoneNumber: false,
          sms: false,
        };
      },
    },
    methods: {
      type: Object,
      default: {},
    },
  },
  setup(props, context) {
    const vm = context.root;
    const store = vm.$store;
    const innerErrMsg = computed({
      get() {
        return props.errMsg;
      },
      set(val) {
        context.emit('update:errMsg', val);
      },
    });
    const innerInvalidNameMsg = computed({
      get() {
        return props.invalidNameMsg;
      },
      set(val) {
        context.emit('update:invalidNameMsg', val);
      },
    });
    const phoneIsCorrect = ref(false);
    const smsIsCorrect = ref(false);
    const agreementRef = ref<AgreementComponent | null>(null);
    const businessOptions = ref(_.cloneDeep(BUSINESS_OPTIONS));
    const scaleOptions = ref(_.cloneDeep(SCALE_OPTIONS));
    const positionOptions = ref(_.cloneDeep(POSITION_OPTIONS));
    const customObj = computed(() => {
      if (formData.value.business) {
        for (const obj of businessOptions.value) {
          if (obj.value === formData.value.business) {
            return {
              subTitleText: obj.description,
              titleBg: obj.icon,
            };
          }
        }
      }
      return {
        subTitleText: i18n_t('获取专属行业解决方案'),
        titleBg: '',
      };
    });
    const { form: formData } = toRefs(props);
    const { methods: registerMethods } = props;
    const { rules } = userValidator(formData.value);
    const registerRules = {
      ...rules,
      business: [
        {
          required: true,
          message: i18n_t('所属行业不能为空'),
          type: 'error',
        },
      ],
      orgName: [
        {
          required: true,
          message: i18n_t('企业名称必填'),
          type: 'error',
          trigger: 'change',
        },
        {
          validator: (val: string) => val.length <= 24,
          message: i18n_t('企业名称不超过24个字'),
        },
      ],
    };
    const methods = {
      industryOptionOnConfirm(value: string) {
        const flag = businessOptions.value.some(item => item.value === value);
        if (flag) {
          return tips.error(i18n_t('该行业已存在'));
        }
        businessOptions.value.push({
          label: value,
          value,
          description: i18n_t('一站式企业文件管理协作平台'),
          icon: 'common-use',
          isCreated: true,
        });
      },
      positionOptionOnConfirm(value: string) {
        const flag = positionOptions.value.some(item => item.value === value);
        if (flag) {
          return tips.error(i18n_t('该职位已存在'));
        }
        positionOptions.value.push({
          label: value,
          value,
        });
      },
      async confirmToRegister() {
        if (!agreementRef.value?.validate()) {
          return;
        }
        if (props.registerLoading) return;
        registerMethods.registerToLogin();
      },
    };
    onMounted(() => {
      registerMethods.initCaptcha();
      reporter.report('free_trial_version', {
        message_show: 'true',
      });
    });

    watch(
      [() => formData.value.code, () => formData.value.phoneNumber, () => formData.value.sms],
      () => {
        phoneIsCorrect.value = validatePhoneNumber(formData.value.code, `${formData.value.phoneNumber}`);
        smsIsCorrect.value = validateSMS(formData.value.sms);
        innerErrMsg.value = '';
      },
      { immediate: true },
    );
    watch(
      () => formData.value.orgName,
      val => {
        innerInvalidNameMsg.value = '';
      },
    );

    return {
      infoHeader,
      enInfoHeader,

      formData,
      registerRules,
      innerErrMsg,
      innerInvalidNameMsg,
      smsIsCorrect,
      phoneIsCorrect,
      agreementRef,
      ConstantConfig,
      businessOptions,
      positionOptions,
      scaleOptions,
      customObj,
      phonePrefixOptions,
      phonePrefixFilter,
      ...methods,
      ...registerMethods,
    };
  },
});
